import React, { lazy } from "react";
import { useSelector } from "react-redux";
import { modalSelector } from "../store/features/modalSlice";

const WarningModal = lazy(() =>
  import("@/common/modal/userCancelActionWarning").then((module) => ({
    default: module.WarningModal,
  }))
);

const MODAL_COMPONENTS: { [key: string]: React.ComponentType<any> } = {
  confirmationModal: WarningModal,
};

export const GlobalModalProvider: React.FC = () => {
  const { isOpen, modalType, props } = useSelector(modalSelector);

  if (!isOpen || !modalType) {
    return null;
  }
  const ModalComponent = MODAL_COMPONENTS[modalType];

  return (
    <React.Suspense fallback={<div>Loading...</div>}>
      <ModalComponent {...props} />
    </React.Suspense>
  );
};
